function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function getArrayMax(array) {
    return Math.max.apply(null, array);
}
let bar_chart = document.querySelectorAll(".bar__container");

['load', 'resize'].forEach(event => {
    window.addEventListener(event, () => {
        // For each bar container start calculating bar chart
        bar_chart.forEach((container) => {
            //Get value of all '.bar__value' and insert it inside array
            var bar_value = container.getElementsByClassName("bar__value"),
                bar_col_value = Object.keys(bar_value).map(idx => (bar_value[idx].getAttribute("value")));

            //Get the highest attribute from bar_col_value Array
            var max_value = getArrayMax(bar_col_value);

            //Loop through each bar from each parent container
            var index = 1;
            let get_bar_value = container.querySelectorAll(".bar__value").forEach(bar => {
                //Get the value of each of "this" container
                let value = bar.getAttribute("value");
                //Do math to convert into percentage
                let percentage = Math.floor((value / max_value) * 100) + "%";

                //Add value to parent element
                bar.parentElement.style.flexBasis = percentage;
                bar.parentElement.style.transitionDelay = index * 100 + "ms";

                //Add commas to value
                bar.setAttribute("value", numberWithCommas(value));

                index++;
            })
        })

    });
});
